import { formatCurrency } from '../lib/catalog';
import { getIsPricelessLot } from '../lib/getIsPricelessLot';

export function renderEstimatedPrices(lowEst: number | null, highEst: number | null, auctionId?: number, lotNumber?: number) {
  if(getIsPricelessLot(auctionId, lotNumber)) {
    return 'Priceless';
  }

  if(lowEst && highEst) {
    return `${formatCurrency(lowEst, { trailingZeroDisplay: 'stripIfInteger' })} - ${formatCurrency(highEst, { trailingZeroDisplay: 'stripIfInteger' })}`;
  }

  if(highEst) {
    return `${formatCurrency(highEst, { trailingZeroDisplay: 'stripIfInteger' })}`;
  }

  return 'Not Available';
}
